/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exclusive_GalleryInputs */

const en_exclusive_gallery = /** @type {(inputs: Exclusive_GalleryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exclusive Gallery`)
};

const es_exclusive_gallery = /** @type {(inputs: Exclusive_GalleryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Galería exclusiva`)
};

const fr_exclusive_gallery = /** @type {(inputs: Exclusive_GalleryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Galerie exclusive`)
};

const de_exclusive_gallery = /** @type {(inputs: Exclusive_GalleryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exklusive Galerie`)
};

const ja_exclusive_gallery = /** @type {(inputs: Exclusive_GalleryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`限定ギャラリー`)
};

const zh_exclusive_gallery = /** @type {(inputs: Exclusive_GalleryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`专属图库`)
};

const ar_exclusive_gallery = /** @type {(inputs: Exclusive_GalleryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`معرض حصري`)
};

const id_exclusive_gallery = /** @type {(inputs: Exclusive_GalleryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Galeri Eksklusif`)
};

const it_exclusive_gallery = /** @type {(inputs: Exclusive_GalleryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Galleria Esclusiva`)
};

const ru_exclusive_gallery = /** @type {(inputs: Exclusive_GalleryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Эксклюзивная галерея`)
};

const pt_exclusive_gallery = /** @type {(inputs: Exclusive_GalleryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Galeria Exclusiva`)
};

const ko_exclusive_gallery = /** @type {(inputs: Exclusive_GalleryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`독점 갤러리`)
};

/**
* | output |
* | --- |
* | "Exclusive Gallery" |
*
* @param {Exclusive_GalleryInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const exclusive_gallery = /** @type {((inputs?: Exclusive_GalleryInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exclusive_GalleryInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exclusive_gallery(inputs)
	if (locale === "es") return es_exclusive_gallery(inputs)
	if (locale === "fr") return fr_exclusive_gallery(inputs)
	if (locale === "de") return de_exclusive_gallery(inputs)
	if (locale === "ja") return ja_exclusive_gallery(inputs)
	if (locale === "zh") return zh_exclusive_gallery(inputs)
	if (locale === "ar") return ar_exclusive_gallery(inputs)
	if (locale === "id") return id_exclusive_gallery(inputs)
	if (locale === "it") return it_exclusive_gallery(inputs)
	if (locale === "ru") return ru_exclusive_gallery(inputs)
	if (locale === "pt") return pt_exclusive_gallery(inputs)
	return ko_exclusive_gallery(inputs)
});